import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DashboardSearchBase } from './common/dashboard-search-base';
import { DashboardBulkSelectionService } from '../../services/dashboard-bulk-selection.service';

/** Full-platform presentation of the shared dashboard search and selection state. */
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  standalone: false,
  providers: [DashboardBulkSelectionService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent extends DashboardSearchBase {}
